import { useContactUs } from "../../../useContactUs";
import { Button } from "@growtherapy/sprout-ui";
import { useTranslate } from "@growtherapy/i18n";

export function ContactSupportButton() {
  const t = useTranslate();
  const { directFormUrl } = useContactUs();
  return (
    <Button
      onClick={() => {
        window.open(directFormUrl, "_blank");
      }}
    >
      {t("telehealth-core:core.contactSupport")}
    </Button>
  );
}
